// extracted by mini-css-extract-plugin
module.exports = {"input":"Checkbox_input__y1C6v","wideRow":"Checkbox_wideRow__OPSeq"};